export default __webpack_public_path__ + "static/media/_table-sort-ascend-active-icon.91f22736.svg";